// extracted by mini-css-extract-plugin
export default {"root":"ItemLink_root__TfYxI"};